/** @jsxImportSource preact */
import * as m from "../../paraglide/messages.js";
import { CARD_STYLES } from "../form/card-styles";
import { FormButton } from "../form/form-button";
import { FORM_STYLES, formVars } from "../form/form-styles";
import { CircleXIcon, CopyIcon } from "../icons";
import type { WidgetTokens } from "../theme";
import {
  CARD_PARTS_STYLES,
  hasStoreContact,
  StatusHeader,
  StoreContactList,
  type WidgetStoreContact,
} from "./card-parts";

export interface ContactUnavailableProps {
  /** 商家的其他联系方式；联系页和电话都没有时，整块「Reach the store another way」不出。 */
  contact: WidgetStoreContact;
  /** 尚未建稿时只呈现中性说明。 */
  neutral?: boolean;
  title?: string;
  /** 买家点了 Copy summary；复制什么、复制后怎么提示都由调用方决定。 */
  onCopySummary?: () => void;
  description?: string;
  disabled?: boolean;
  tokens: WidgetTokens;
}

export const CONTACT_UNAVAILABLE_STYLES = `${CARD_PARTS_STYLES}
.gn-unavailable-other { display:flex; flex-direction:column; gap:8px; }
.gn-unavailable-label { padding:0 4px; }
`;

/**
 * 商家邮箱暂时不可用，请求没有发出去：出错头（危险色图标圆，role=alert，读屏立刻播报）、一句说明，
 * 然后是井里的联系页和电话，最后一个撑满的墨黑 Copy summary，让买家把请求摘要带走自己联系商家。
 */
export function ContactUnavailable({
  contact,
  neutral,
  title,
  description,
  disabled,
  onCopySummary,
  tokens: t,
}: ContactUnavailableProps) {
  return (
    <div class="gn-card" data-strong="" style={formVars(t)}>
      <style>{`${FORM_STYLES}${CARD_STYLES}${CONTACT_UNAVAILABLE_STYLES}`}</style>
      <StatusHeader
        icon={<CircleXIcon size={18} />}
        live={neutral ? "status" : "alert"}
        subtitle={description ?? m.widget_unavailable_message()}
        title={title ?? m.widget_unavailable_title()}
        tone={neutral ? "ink" : "danger"}
      />
      {hasStoreContact(contact) && (
        <div class="gn-unavailable-other">
          <div class="gn-caption gn-unavailable-label">
            {m.widget_unavailable_other_way()}
          </div>
          <StoreContactList contact={contact} />
        </div>
      )}
      {onCopySummary && (
        <FormButton
          fullWidth
          disabled={disabled}
          onClick={onCopySummary}
          tokens={t}
        >
          <CopyIcon size={14} />
          {m.widget_unavailable_copy()}
        </FormButton>
      )}
    </div>
  );
}
